import { ref } from "vue";
import { useCommonRules } from "./common";

export function useUserRules(t) {
  const { required } = useCommonRules(t);
  const emailRules = ref([
    required,
    (v) => /.+@.+/.test(v) || t("validations.invalid-format")
  ]);

  const passwordRules = ref([
    required,
    (v) => v.length >= 6 || t("validations.too-short")
  ]);

  return {
    emailRules,
    passwordRules
  };
}
